// Client-safe editorial vocabulary for wisdom articles.
// Kept out of wisdom.server.ts so routes and admin UI can import it.

export type ArticleKind =
  | "evergreen"
  | "song-meaning"
  | "beat-breakdown"
  | "process"
  | "release-support";

export const ARTICLE_KINDS: readonly ArticleKind[] = [
  "evergreen",
  "song-meaning",
  "beat-breakdown",
  "process",
  "release-support",
];

export const ARTICLE_KIND_LABELS: Record<ArticleKind, string> = {
  evergreen: "Essay",
  "song-meaning": "Song meaning",
  "beat-breakdown": "Beat breakdown",
  process: "Process",
  "release-support": "Release notes",
};

/** Public editorial article, as rendered on buddhaka.com. */
export interface PublicWisdomPost {
  slug: string;
  title: string;
  category: string;
  readingTime: string;
  excerpt: string;
  pullQuote: string;
  body: string[];
  tags?: string[];
  relatedMusic?: string;
  relatedActivation?: string;
  relatedBook?: string;
  articleKind: ArticleKind;
  metaTitle: string | null;
  metaDescription: string | null;
  ogImageUrl: string | null;
  canonicalPath: string | null;
  relatedReleaseSlug: string | null;
  relatedSongSlug: string | null;
  relatedBeatSlug: string | null;
  publishedAt: string | null;
  updatedAt: string | null;
}
